import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface MetasPlanPayload {
  tipo_meta: number;
  fecha_programacion: Date;
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface MetasPlan {
  id?: number;
  tipo_meta: number;
  descripcion: string;
  fecha_programacion: Date; // 👈 ya la trae getAll() (no está en el exclude), solo faltaba tipada
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
  TipoMetaPlanData?: { id: number; descripcion: string };
  SeguimientosMetasData?: { id: number; fechaCreacion: string; estado: number }[];
}

export interface MetasPlanResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class MetasPlanService {
  private readonly apiUrl = `${environment.apiUrl}/api/metas_plan`;

  constructor(private http: HttpClient) {}

  // Listar todas las metas
  getAll(): Observable<MetasPlan[]> {
    return this.http.get<MetasPlan[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<MetasPlan> {
    return this.http.get<MetasPlan>(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }

  // Crear nueva meta
  create(payload: MetasPlanPayload): Observable<MetasPlanResponse> {
    return this.http.post<MetasPlanResponse>(this.apiUrl, payload, {
      withCredentials: true,
    });
  }

  // Actualizar meta
  update(
    id: number,
    payload: Partial<MetasPlanPayload>,
  ): Observable<MetasPlanResponse> {
    return this.http.put<MetasPlanResponse>(`${this.apiUrl}/${id}`, payload, {
      withCredentials: true,
    });
  }

  // Eliminar meta (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }

  // Inactivar meta
  inactivar(id: number): Observable<MetasPlanResponse> {
    return this.http.put<MetasPlanResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      { withCredentials: true },
    );
  }

  // Activar meta
  activar(id: number): Observable<MetasPlanResponse> {
    return this.http.put<MetasPlanResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      { withCredentials: true },
    );
  }
}